import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { map, Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { FinnairOrder } from '@fcom/dapi/api/models';
import { BookingAndAppState } from '@fcom/common/interfaces/booking';
import { orderData } from '@fcom/common-booking';
import { CmsPageService } from '@fcom/common/services';
import { CmsImageData } from '@fcom/core-api';
import { SentryLogger } from '@fcom/core';

import { CarTrawlerClientID } from '../../../constants';

@Component({
  selector: 'fin-mmb-car-rental-route',
  templateUrl: './car-rental-route.component.html',
  styleUrls: ['../../../../common-booking/assets/helper-classes.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ManageBookingCarRentalRouteComponent implements OnInit {
  order$: Observable<FinnairOrder>;
  airportTransfersImage$: Observable<CmsImageData>;

  clientId = CarTrawlerClientID.MMB_CAR_RENTAL_AIRPORT_TRANSFERS;

  constructor(
    private router: Router,
    private store$: Store<BookingAndAppState>,
    private pageService: CmsPageService,
    private sentryLogger: SentryLogger
  ) {}

  ngOnInit(): void {
    this.order$ = this.store$.pipe(orderData());
    this.airportTransfersImage$ = this.pageService.getPageData(this.router.url).pipe(
      map((template) => {
        if (!template.main?.[0]) {
          this.sentryLogger.error('Missing picture for airport transfers component in manage booking');
        }

        return template.main[0] as CmsImageData;
      })
    );
  }
}
